export default __webpack_public_path__ + "f0d76bc5785db3a5cfcd5c184753738f.png";